import React from "react";

const CloneV2 = ({ width = 28, height = 28, fill = "#D3D3D3" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15.8996" cy="8" r="7.25" stroke={fill} strokeWidth="1.5" />
    <circle
      cx="8.43365"
      cy="8"
      r="7.25"
      fill={fill}
      stroke={fill}
      strokeWidth="1.5"
    />
  </svg>
);

export default CloneV2;
